import React from 'react'

export const About = () => {
    return (
        <div>
            Planno web app v1.0.1, created by Janine Newton. 
        </div>
    )
}
